import TopBar from "./TopBar";

const Header = () => {
    return <TopBar />
}

export default Header;
